export default "__VITE_ASSET__CGdKrFFC__"